function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  d: "M0 0v21.574c16.399 0 29.695 3.485 29.695 7.785v43.97C29.695 77.63 16.4 83.616 0 83.616L.058 91H73V0",
  id: "pfx67970__a"
}), /*#__PURE__*/React.createElement("path", {
  d: "M.792 0L0 52.326h5.928C5.928 56.563 19.014 60 35.155 60c16.143 0 29.228-3.437 29.228-7.674H70L67.133 1.39",
  id: "pfx67970__c"
}), /*#__PURE__*/React.createElement("path", {
  d: "M.792 0L0 52.326h5.928C5.928 56.563 19.014 60 35.155 60c16.143 0 29.228-3.437 29.228-7.674H70L67.133 1.39",
  id: "pfx67970__e"
}), /*#__PURE__*/React.createElement("path", {
  d: "M.792 0L0 52.326h5.928C5.928 56.563 19.014 60 35.155 60c16.143 0 29.228-3.437 29.228-7.674H70L67.133 1.39.793 0z",
  id: "pfx67970__g"
}), /*#__PURE__*/React.createElement("path", {
  d: "M.792 0L0 52.326h5.928C5.928 56.563 19.014 60 35.155 60c16.143 0 29.228-3.437 29.228-7.674H70L67.133 1.39.793 0z",
  id: "pfx67970__i"
}), /*#__PURE__*/React.createElement("path", {
  d: "M.792 0L0 52.326h5.928C5.928 56.563 19.014 60 35.155 60c16.143 0 29.228-3.437 29.228-7.674H70L67.133 1.39.793 0z",
  id: "pfx67970__k"
}), /*#__PURE__*/React.createElement("filter", {
  id: "pfx67970__m"
}, /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceGraphic",
  values: "0 0 0 0 0.921569 0 0 0 0 0.929412 0 0 0 0 0.890196 0 0 0 1.000000 0"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(156 29)",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M36 71.997c6-41-26-55-25.754-77 .245-22 33-24 45-12s19 18 38 41 51-6 35-21-51 9-78 4",
  stroke: "#EBEDE3",
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M66 60c0 4.419-13.655 8-30.5 8S5 64.419 5 60c0-4.419 13.655-8 30.5-8S66 55.581 66 60",
  fill: "#544D44"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(36.3 30.5)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "pfx67970__b",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#pfx67970__a"
})), /*#__PURE__*/React.createElement("path", {
  d: "M11.914 23.849c3.364-2.637 14.24 5.832 24.296 18.916 10.056 13.083 15.481 25.826 12.117 28.462-3.363 2.637-14.24-5.832-24.297-18.916C13.974 39.228 8.55 26.485 11.914 23.849",
  fill: "#544D44",
  mask: "url(#pfx67970__b)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M54.417 66.454l-6.09 4.773c3.365-2.637-2.06-15.38-12.116-28.462-10.056-13.083-20.934-21.553-24.297-18.917l6.09-4.772c3.363-2.637 14.241 5.832 24.297 18.916 10.056 13.082 15.48 25.825 12.116 28.462",
  fill: "#CAC5B8",
  mask: "url(#pfx67970__b)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(5 60)",
  fill: "#CAC5B8"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 12c0 4.372 13.655 7.915 30.5 7.915S61 16.372 61 12v32.542C61 48.914 47.345 55 30.5 55S0 48.914 0 44.542V12z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 8V0c0 4.419 13.655 8 30.5 8S61 4.419 61 0v8c0 4.419-13.655 8-30.5 8S0 12.419 0 8"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 8)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "pfx67970__d",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#pfx67970__c"
})), /*#__PURE__*/React.createElement("path", {
  d: "M5.335 44.96l9.905-6.817 1.012 1.502c.37.551 1.12.695 1.664.32a1.225 1.225 0 0 0 .317-1.685l-1.012-1.501 8.915-6.136 1.011 1.502c.37.551 1.12.695 1.664.32a1.223 1.223 0 0 0 .317-1.683l-1.011-1.503 8.914-6.136 1.011 1.504c.371.549 1.12.693 1.665.318a1.223 1.223 0 0 0 .317-1.683l-1.012-1.502 4.953-3.41a1.193 1.193 0 0 1 1.665.32l3.035 4.508L8.053 51.15 5.02 46.643a1.223 1.223 0 0 1 .316-1.683",
  fill: "#CAC5B8",
  mask: "url(#pfx67970__d)"
}), /*#__PURE__*/React.createElement("mask", {
  id: "pfx67970__f",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#pfx67970__e"
})), /*#__PURE__*/React.createElement("path", {
  d: "M63.854 47.919l-38.63 26.59a1.193 1.193 0 0 1-1.664-.321L9.402 53.155l40.61-27.953L64.17 46.236c.37.55.228 1.308-.317 1.683",
  fill: "#EBEDE3",
  mask: "url(#pfx67970__f)"
}), /*#__PURE__*/React.createElement("mask", {
  id: "pfx67970__h",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#pfx67970__g"
})), /*#__PURE__*/React.createElement("path", {
  d: "M39.013 21.78L38 20.278c-1.314-1.954-3.895-2.449-5.825-1.12a4.242 4.242 0 0 0-1.108 5.891l1.012 1.504 1.98-1.365-1.01-1.501c-.575-.852-.37-1.946.473-2.525.843-.581 1.924-.372 2.497.479l1.011 1.502 1.012 1.503c.37.551 1.12.696 1.664.32a1.225 1.225 0 0 0 .317-1.684l-1.011-1.502z",
  fill: "#544D44",
  mask: "url(#pfx67970__h)"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
  id: "pfx67970__j",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#pfx67970__i"
})), /*#__PURE__*/React.createElement("path", {
  d: "M26.136 30.643l1.011 1.502c.371.55 1.12.695 1.665.32a1.223 1.223 0 0 0 .317-1.683l-1.012-1.503-1.011-1.502c-1.315-1.953-3.895-2.45-5.828-1.12a4.244 4.244 0 0 0-1.105 5.893l1.01 1.501 1.98-1.362-1.01-1.504a1.797 1.797 0 0 1 .475-2.524c.84-.58 1.924-.372 2.496.48l1.012 1.502z",
  fill: "#544D44",
  mask: "url(#pfx67970__j)"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
  id: "pfx67970__l",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#pfx67970__k"
})), /*#__PURE__*/React.createElement("path", {
  d: "M15.24 38.142l1.012 1.502c.37.551 1.12.696 1.664.32a1.223 1.223 0 0 0 .317-1.682l-1.011-1.502-1.012-1.504c-1.314-1.952-3.894-2.449-5.827-1.12a4.244 4.244 0 0 0-1.106 5.893l1.01 1.502 1.982-1.363-1.012-1.503a1.797 1.797 0 0 1 .475-2.525c.841-.58 1.924-.371 2.497.48l1.011 1.502z",
  fill: "#544D44",
  mask: "url(#pfx67970__l)"
}))), /*#__PURE__*/React.createElement("g", {
  transform: "rotate(103 36.956 14.847)",
  filter: "url(#pfx67970__m)"
}, /*#__PURE__*/React.createElement("g", {
  stroke: "#E84A32",
  strokeLinecap: "round"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(8.527 4.857)"
}, /*#__PURE__*/React.createElement("path", {
  transform: "rotate(-108 5.08 4.235)",
  d: "M2.888 8.864L7.272 -0.394"
}), /*#__PURE__*/React.createElement("path", {
  transform: "rotate(-108 8.187 13.798)",
  d: "M9.914 18.619L6.459 8.977"
}), /*#__PURE__*/React.createElement("path", {
  transform: "rotate(-108 16.403 19.587)",
  d: "M21.112 21.613L11.694 17.561"
}), /*#__PURE__*/React.createElement("path", {
  transform: "rotate(-108 27.242 13.95)",
  d: "M31.353 10.891L23.13 17.01"
}), /*#__PURE__*/React.createElement("path", {
  transform: "rotate(-108 29.865 2.526)",
  d: "M30.517 -2.553L29.212 7.604"
})), /*#__PURE__*/React.createElement("path", {
  d: "M8.974 16.332L4 18.05"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0.974 19.332L0.375 19.632"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20.668 23.801L17.502 27.876"
}), /*#__PURE__*/React.createElement("path", {
  d: "M33.668 0.801L30.502 4.876"
}), /*#__PURE__*/React.createElement("path", {
  d: "M31.075 21L33.388 25.72"
}), /*#__PURE__*/React.createElement("path", {
  d: "M35.075 29L35.375 29.632"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.075 0L21.388 4.72"
}), /*#__PURE__*/React.createElement("path", {
  d: "M35.341 12.426L40.424 13.399"
}), /*#__PURE__*/React.createElement("path", {
  d: "M45.341 14.426L46.375 14.632"
})), /*#__PURE__*/React.createElement("circle", {
  fill: "#E84A32",
  cx: 26.875,
  cy: 10.132,
  r: 1
})));

function SvgQ4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 382,
    height: 146,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQ4);
export default __webpack_public_path__ + "static/media/q4.d412b85a.svg";
export { ForwardRef as ReactComponent };